import React, { useState } from "react";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import Notification from "../components/Notification";
import InputField from "../components/InputField";
import { changePassword } from "../services/authService";
import { useAuth } from "../hooks/AuthProvider";

export default function ProfilePage() {
	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	const [loading, setLoading] = useState(false);
	const auth = useAuth();

	const handlePasswordChange = async (e) => {
		e.preventDefault();
		setError(null);
		setSuccess(null);

		if (!currentPassword || !newPassword || !confirmPassword) {
			setError("Tutti i campi sono obbligatori.");
			return;
		}
		if (newPassword !== confirmPassword) {
			setError("Le password non corrispondono.");
			return;
		}

		setLoading(true);
		changePassword(auth, currentPassword, newPassword)
			.then((res) => {
				if (res.success) {
					setSuccess("Password modificata con successo.");
					setCurrentPassword("");
					setNewPassword("");
					setConfirmPassword("");
				} else setError(res.message || "Si è verificato un errore");
			})
			.catch((data) => setError(data.message || "Si è verificato un errore"))
			.finally(() => setLoading(false));
	};

	return (
		<AuthenticatedLayout title="Profilo">
			<div className="container mt-5">
				<h3 className="subtitle">Modifica Password</h3>
				{error && <Notification notification={{ type: 0, message: error }} />}
				{success && <Notification notification={{ type: 3, message: success }} />}

				<form onSubmit={handlePasswordChange}>
					<InputField
						type={"password"}
						placeholder={"Password Attuale"}
						label={"Password Attuale"}
						onChange={(e) => setCurrentPassword(e.target.value)}
					/>
					<InputField
						type={"password"}
						placeholder={"Nuova Password"}
						label={"Nuova Password"}
						onChange={(e) => setNewPassword(e.target.value)}
					/>
					<InputField
						type={"password"}
						placeholder={"Conferma Password"}
						label={"Conferma Password"}
						onChange={(e) => setConfirmPassword(e.target.value)}
					/>
					{/* <span className="has-text-danger has-text-weight-semibold p-2 is-size-5">{error}</span> */}
					<div className="field mt-4">
						<div className="control">
							<button type="submit" className={`button is-link ${loading ? "is-loading" : ""}`}>
								Cambia Password
							</button>
						</div>
					</div>
				</form>
			</div>
		</AuthenticatedLayout>
	);
}
